import { render, staticRenderFns } from "./appeal-byoc.vue?vue&type=template&id=c5206f7c&scoped=true"
import script from "./appeal-byoc.vue?vue&type=script&lang=js"
export * from "./appeal-byoc.vue?vue&type=script&lang=js"
import style0 from "./appeal-byoc.vue?vue&type=style&index=0&id=c5206f7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5206f7c",
  null
  
)

export default component.exports